import { Dialog, DialogTitle } from "@mui/material"
import { useState } from "react";
import { Api } from "../../shared/api";
import { Lead } from "@dragonsight/models";
import { LeadForm, LeadFormValues } from "./leadForm";

const EditLeadDialog = (props: {lead?: Lead, show: boolean, onClose: () => void, onLeadEdit: (value: Lead) => void}) => {
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (values: LeadFormValues) => {
        setSubmitting(true);

        try {
            const newLead = await Api.Crm.Edit({
                id: props.lead!.id,
                accountId: props.lead!.accountId,
                name: values.name!,
                company: values.company!,
                note: values.notes,
                platforms: values.platforms,
                contacts: values.contacts,
                messages: [],
            });
            props.onLeadEdit(newLead);
            props.onClose();
        } catch (error: any) {

        }
        finally {
            setSubmitting(false);
        }
    }

    return <Dialog open={props.show && props.lead !== undefined} onClose={props.onClose}>
        <DialogTitle>Edit {props.lead?.name ?? ""}</DialogTitle>
        <LeadForm lead={props.lead} onSubmit={(values) => handleSubmit(values)} onCancel={props.onClose} submitting={submitting} />
    </Dialog>
}

export default EditLeadDialog